import elliePic from "@/public/images/artists/ellie.jpg";
import { Artist } from "@/types/types";

export const ellie = {
  id: "257",
  name: "Ellie",
  image: elliePic,
  description: `Ellie's voice is soft and close-miked, with a breathy, comforting tone that feels almost whispered. Even at its lightest, her sound stays focused and deliberate with cool, hypnotic ease.`,
  previewUrl:
    "https://public-assets.audimeestorage.com/artistPreviews%2Fellie-preview.mp3",
  meta: {
    free: false,
    new: false,
  },
  filters: {
    gender: "Female",
    tags: {
      primary: ["Airy", "Alternative", "Pop", "Indie", "Unprocessed"],
      secondary: [],
    },
    pitchRange: {
      categories: {
        low: "Mid",
        high: "High",
      },
      specific: {
        low: 55,
        high: 72,
      },
      sweetSpot: 64,
    },
  },
} as const satisfies Artist;
